export default __webpack_public_path__ + "static/media/menu-appointments-icon.6cb782df.svg";